import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SeoService } from '../services/seo.service';

@Injectable()
export class SeoGuard implements CanActivate {

  constructor(private seoService: SeoService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const id =  next.params['id'];
    let pageName = '';
   
    if(['contentpages','catererpages'].includes(next.data.type)){
      pageName =  next.params['pageName'];
    }
    this.seoService.getRouteSeo(next.data.type, id,pageName);
    return true;
  }
}
